<template>
    <div id='adminnews'>
        <div class="container">
            <p>Background Management</p>
            <div class="loginBox">
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="Username" prop="adminname">
                        <el-input type="text" v-model="ruleForm.adminname" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="Password" prop="adminpass">
                        <el-input type="password" v-model="ruleForm.adminpass" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item class="botton1">
                        <el-button type="primary" @click="submitForm('ruleForm')" style="margin-left:-199px;">Submit</el-button>
                        <el-button @click="resetForm('ruleForm')">Reset</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from '@/api/http';

export default {
        data() {
            var validateAdminname = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('Enter one user name'));
                } else {
                    callback();
                }
            };
            var validatePass = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('Please enter the password'));
                } else {
                    callback();
                }
            };

            return {
                ruleForm: {
                    adminname: '',
                    adminpass: '',
                },
                rules: {
                    adminname: [
                        { validator: validateAdminname, trigger: 'blur' }
                    ],
                    adminpass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                },
            };
        },

        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        request('/CalawaEnServlet/UserServlet', {
                            action: 'login',
                            username: this.ruleForm.adminname,
                            password: this.ruleForm.adminpass,
                        })
                        .then(res => {
                            if(res.data.result !== false){
                                //存登录态：用户名 + 管理员标记
                                sessionStorage.setItem('loginin', res.data.username || '');
                                sessionStorage.setItem('isAdmin', res.data.isAdmin || 0);

                                //存在回跳地址就回跳，否则进入后台新闻展示页
                                const redirect = this.$route.query.redirect;
                                if (redirect) {
                                    this.$router.push(decodeURIComponent(redirect));
                                } else {
                                    this.$router.push({ path: '/listnews/0/1' });
                                }
                            }else{
                                alert('Account or password incorrect!');
                            }
                        }).catch(() => {
                            this.$message.error('Login failed, please try again');
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        },

        computed: {
            //为了监听msg1数据的变化
            // listenlogin(){
            //     return this.$route.query.redirect;
            // }
        },

        watch: {
            // listenlogin:function(){
            //     const redirect = this.$route.query.redirect
            //     if(redirect){
            //         //存在回跳地址就回跳
            //         this.$router.push(redirect)

            //         sessionStorage.setItem('loginin',null);
            //     }else{
            //         //否则就跳到默认的首页
            //         this.$router.push({
            //         name: 'index'
            //         })
            //     }
            // }
        }

    }
</script>

<style lang="scss" scoped>
    #adminnews{
        width: 100%;
        min-height: 100%;
        height:757px;

        background: url(../assets/adminnews/01.jpg) no-repeat;

        overflow: auto;

        .container{
            width: 500px;
            // height:320px;

            background-color: rgba(255,255,255,0.4);

            position: absolute;
            top: 200px;
            left: 200px;

            p:first-child{
                font-size: 30px;
                font-family: '楷体';
                font-weight: 600;

                text-align: left;
                margin: 20px 0 20px 20px;
            }

            .loginBox{
                width: 500px;
                height: 230px;

                border-top: 2px solid white;

                .el-form{
                    width: 450px;
                    margin-top: 40px;
                }
            }
        }
    }
</style>

